import React from "react";
import {
  IonButtons,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonContent,
  IonProgressBar,
  IonButton, IonModal
} from "@ionic/react";
import {EventoObject} from "../../models/Evento";
import fb from '../../lib/firebase';
import {
  QuestionarioFazendaObject,
  QuestionarioLojaObject,
  QuestionarioObject,
  QuestionarioVeterinarioObject
} from "../../models/Questionario";
import {FormQuestionarioLoja} from "./questionarios/FormQuestionarioLoja";
import {FormQuestionarioVeterinario} from "./questionarios/FormQuestionarioVeterinario";
import {QuestionarioLoja} from "./questionarios/QuestionarioLoja";
import {QuestionarioVeterinario} from "./questionarios/QuestionarioVeterinario";
import {QuestionarioFazenda} from "./questionarios/QuestionarioFazenda";
import {prepareFazenda} from "../../models/Fazenda";
import {FormQuestionarioFazenda} from "./questionarios/FormQuestionarioFazenda";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {actions} from "../../lib/app";
import {connect} from "react-redux";
import {dataInCurrentMonth} from "../../lib/utils";
import {debug} from "../../config";


interface Props {
  app: AppState;
  dispatch: AppDispatch;
  history: any;
  instance: EventoObject;
}

interface State {
  loadingPrincipal: boolean;
  loadingQuestionario: boolean;
  questionario: QuestionarioObject | undefined;
  novoQuestionario: boolean;
  tipo: string | undefined;
  principal: any;
  allowDelete: boolean;
}

class AbaQuestionario extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loadingPrincipal: true,
      loadingQuestionario: true,
      questionario: undefined,
      novoQuestionario: false,
      tipo: undefined,
      principal: undefined,
      allowDelete: false,
    };
  }

  componentDidMount() {
    this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});
    this.loadPrincipal();
    this.loadQuestionario();
  }

  loadPrincipal() {
    // carregar principal
    this.props.instance.principal.path.get()
      .then(snap => {
          const principal = fb.doc(snap);
          debug(`AbaQuestionario.loadPrincipal`, principal);
          let vo :any = principal;
          let tipo = principal.type;
          if (tipo === 'fazendas')
            vo = prepareFazenda(principal);

          this.setState({
            principal: vo,
            tipo,
            loadingPrincipal: false,
          });
        }
      )
  }

  loadQuestionario() {
    this.setState({
      loadingQuestionario: true,
      questionario: undefined,
    }, () => {
      fb.db.collection('questionarios')
        .where('owner', '==', this.props.app.user.uid)
        .where('evento.path', '==', fb.db.collection('eventos').doc(this.props.instance.id))
        .limit(1).get()
          .then(snap => {
            const questionario = fb.first(snap);
            if (questionario)
              debug(questionario.path);
            this.setState({questionario, loadingQuestionario: false});
          })
          .catch(() => {
            this.props.dispatch(actions.notifyError('Erro ao obter questionário!'));
            this.setState({loadingQuestionario: false});
          });
    })
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevProps.instance && this.props.instance && prevProps.instance.id !== this.props.instance.id) {
      this.setState({allowDelete: dataInCurrentMonth(this.props.instance.criado_em.toDate())});
    }
  }

  onClickAdicionarQuestionario = () => {
    this.setState({novoQuestionario: true});
  };

  onCloseForm = () => {
    this.setState({novoQuestionario: false});
  };

  onSubmit = () => {
    this.setState({novoQuestionario: false}, this.loadQuestionario);
  };

  onDelete = () => {
    fb.db.collection('questionarios').doc(this.state.questionario!.id).delete()
      .then(() => {
        this.props.dispatch(actions.notifySuccess('Questionário excluído com sucesso.'));
        this.loadQuestionario();
      });
  };

  onReload = () => {
    this.setState({novoQuestionario: false}, this.loadQuestionario);
  };

  render() {
    if (this.state.loadingPrincipal || this.state.loadingQuestionario)
      return <IonProgressBar type="indeterminate"/>;

    const questionarioProps:any = {
      history: this.props.history,
      onDelete: this.onDelete,
      onReload: this.onReload,
      evento: this.props.instance,
      principal: this.state.principal,
    };

    const formQuestionarioProps:any = {
      evento: this.props.instance,
      principal: this.state.principal,
      onSubmit: this.onSubmit,
    };

    return (
      <div className="flex flex-col h-full">
        {
          this.state.questionario &&
            <>
              {
                this.state.tipo === 'lojas' &&
                  <QuestionarioLoja
                    {...questionarioProps}
                    allowDelete={this.state.allowDelete}
                    questionario={this.state.questionario as QuestionarioLojaObject}
                  />
              }
              {
                this.state.tipo === 'veterinarios' &&
                  <QuestionarioVeterinario
                    {...questionarioProps}
                    allowDelete={this.state.allowDelete}
                    questionario={this.state.questionario as QuestionarioVeterinarioObject}
                  />
              }
              {
                this.state.tipo === 'fazendas' &&
                  <QuestionarioFazenda
                    {...questionarioProps}
                    allowDelete={this.state.allowDelete}
                    questionario={this.state.questionario as QuestionarioFazendaObject}
                  />
              }
            </>
        }

        {
          !this.state.questionario &&
          <div className="flex w-full h-full items-center justify-center ion-padding">
            <div className="text-center">
              <div>
                Este evento não tem um questionário preenchido.
              </div>
              {this.state.allowDelete &&
                <IonButton className="mt-4" fill="outline"
                           onClick={this.onClickAdicionarQuestionario}>
                  Adicionar questionário
                </IonButton>
              }
            </div>
          </div>
        }

        <IonModal
          isOpen={this.state.novoQuestionario}
          onDidDismiss={this.onCloseForm}
        >
          <IonHeader>
            <IonToolbar>
              <IonTitle>
                Adicionar Questionário
              </IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={this.onCloseForm}>
                  Cancelar
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>

          <IonContent className="ion-padding">
            {
              this.state.tipo === 'lojas' &&
              <FormQuestionarioLoja {...formQuestionarioProps}/>
            }
            {
              this.state.tipo === 'veterinarios' &&
              <FormQuestionarioVeterinario {...formQuestionarioProps}/>
            }
            {
              this.state.tipo === 'fazendas' &&
              <FormQuestionarioFazenda {...formQuestionarioProps}/>
            }
          </IonContent>
        </IonModal>
      </div>
    )
  }
}

export default connect(({app}: RootState) => ({app}))(AbaQuestionario);